/**
 * دادهٔ تستی مگامنو — بعداً با ماژول دسته‌بندی جایگزین می‌شود.
 */

export interface MegaLinkItem {
  id: string;
  label: string;
  description: string;
  href: string;
  badge?: string;
  /** آدرس کامل تصویر بندانگشتی (مثل خروجی getImageUrl) — برای دسته‌های دوره */
  thumbnailUrl?: string | null;
}

export interface MegaCategoryColumn {
  id: string;
  title: string;
  subtitle: string;
  items: MegaLinkItem[];
}

export const MOCK_COURSE_COLUMNS: MegaCategoryColumn[] = [
  {
    id: 'mind',
    title: 'ذهن و تمرکز',
    subtitle: '۳ عنوان آزمایشی',
    items: [
      {
        id: 'c1',
        label: 'مدیریت ذهن مضطرب',
        description: 'تکنیک‌های آرام‌سازی شناختی',
        href: '/courses',
        badge: 'پرفروش',
      },
      {
        id: 'c2',
        label: 'تمرکز عمیق کاری',
        description: '۴ هفته تمرین هدفمند',
        href: '/courses',
      },
      {
        id: 'c3',
        label: 'خواب و بازتوانی ذهنی',
        description: 'الگوهای رفتاری قبل از خواب',
        href: '/courses',
      },
    ],
  },
  {
    id: 'career',
    title: 'مسیر شغلی',
    subtitle: '۲ عنوان آزمایشی',
    items: [
      {
        id: 'c4',
        label: 'برندسازی شخصی',
        description: 'از داستان شخصی تا ارائه حرفه‌ای',
        href: '/courses',
      },
      {
        id: 'c5',
        label: 'مذاکره و ارتباط',
        description: 'چارچوب مکالمه اثرگذار',
        href: '/courses',
      },
    ],
  },
  {
    id: 'events',
    title: 'رویداد و تجربه',
    subtitle: '۲ عنوان آزمایشی',
    items: [
      {
        id: 'c6',
        label: 'کارگاه‌های حضوری',
        description: 'ثبت‌نام از صفحه اصلی',
        href: '/',
      },
      {
        id: 'c7',
        label: 'بسته‌های ترکیبی',
        description: 'ویدیو + جلسه راهنما',
        href: '/courses',
        badge: 'جدید',
      },
    ],
  },
];

export const MOCK_PODCAST_COLUMNS: MegaCategoryColumn[] = [
  {
    id: 'audio',
    title: 'پادکست صوتی',
    subtitle: 'سری‌های آزمایشی',
    items: [
      {
        id: 'p1',
        label: 'قهرمان درون',
        description: 'فصل ۱ تا ۳ · داستانی انگیزشی',
        href: '/podcasts',
        badge: 'محبوب',
      },
      {
        id: 'p2',
        label: 'گفت‌وگو با ذهن',
        description: 'اپیزودهای کوتاه هفتگی',
        href: '/podcasts',
      },
    ],
  },
  {
    id: 'video',
    title: 'پادکست ویدیویی',
    subtitle: 'محتوای تصویری',
    items: [
      {
        id: 'p3',
        label: 'استودیو نور',
        description: 'مصاحبه با متخصصان',
        href: '/video-podcasts',
      },
      {
        id: 'p4',
        label: 'کلاس کوتاه تصویری',
        description: 'جمع‌بندی مفاهیم کلیدی',
        href: '/video-podcasts',
        badge: 'جدید',
      },
    ],
  },
  {
    id: 'soon',
    title: 'به‌زودی',
    subtitle: 'در دست انتشار',
    items: [
      {
        id: 'p5',
        label: 'نسخه انحصاری اعضا',
        description: 'دسترسی زودهنگام · داده تستی',
        href: '/podcasts',
      },
    ],
  },
];
